import { forwardRef, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NzInputModule } from 'ng-zorro-antd/input';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';

import { AutoFocusDirective } from '@shared/_utils/autofocus.component';
import { AvatarComponent } from '@shared/_views/avatar';
import { TagsSelectComponent } from '@shared/_controls/tags-select.component';
import { ProjectSelectComponent } from '@shared/_controls/project-select.component';
import { UserOrGroupSelectComponent } from '@shared/_controls/person-or-group-select.component';

import { FilterFormComponent } from './filter-form.component';

@NgModule({
    imports: [
        CommonModule, FormsModule,
        NzInputModule, NzToolTipModule, NzSelectModule, NzDatePickerModule, NzCheckboxModule,
        forwardRef(() => TagsSelectComponent), AutoFocusDirective, AvatarComponent, ProjectSelectComponent, UserOrGroupSelectComponent
    ],
    declarations: [FilterFormComponent],
    exports: [FilterFormComponent]
})
export class FilterFormModule { }
